function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 2.316a9.863 9.863 0 01-2.832.762A4.906 4.906 0 0023.33.366a9.71 9.71 0 01-3.12 1.189A4.906 4.906 0 0016.615 0 4.917 4.917 0 0011.7 4.92c0 .381.046.762.12 1.128A13.977 13.977 0 011.68.9a4.884 4.884 0 00-.67 2.483c0 1.708.869 3.213 2.193 4.099a4.96 4.96 0 01-2.224-.626v.06a4.92 4.92 0 003.943 4.829 5.21 5.21 0 01-1.295.167c-.32 0-.623-.032-.93-.075a4.927 4.927 0 004.598 3.412 9.857 9.857 0 01-6.106 2.103c-.412 0-.793-.015-1.188-.06a13.927 13.927 0 007.554 2.206c9.045 0 13.994-7.494 13.994-13.998 0-.213 0-.427-.014-.64.957-.7 1.797-1.569 2.466-2.544z"
});

function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 20",
    fill: "none"
  }, props), _ref);
}

export default SvgTwitterIcon;